<template>
  <BaseVeeForm
    :action="save"
    ensure-error-keys-camel-case
    v-slot="{ isPending, invalid }"
    class="space-y-2"
    @success="showActions = false"
  >
    <div>
      <ValidationProvider :rules="rules" :name="label" slim :vid="name">
        <template #default="{ errors }">
          <BaseFormGroup>
            <BaseFormLabel :for="name">
              {{ label }}
            </BaseFormLabel>
            <BaseFormTextarea
              :id="name"
              :class="inputClasses"
              v-model="formData[name]"
              :disabled="isPending"
              @focus="showActions = true"
            />
            <BaseFormInlineMessage v-if="errors.length" danger>
              {{ errors[0] }}
            </BaseFormInlineMessage>
          </BaseFormGroup>
        </template>
      </ValidationProvider>
    </div>

    <div v-if="showActions" class="flex space-x-2">
      <BaseButton primary small :disabled="invalid || isPending"> Save </BaseButton>
      <BaseButton type="button" primary outline small :disabled="isPending" @click="cancel">
        Cancel
      </BaseButton>
    </div>
  </BaseVeeForm>
</template>

<script>
export default {
  props: {
    name: {
      type: String,
      required: true,
    },
    label: {
      type: String,
      default: 'Property label',
    },
    rules: {
      type: [String, Object, Function],
      default: '',
    },
    value: {
      type: String,
      default: '',
    },
    saveAction: {
      type: Function,
      default: async (formData) => {
        this.$emit('save', formData);

        return true;
      },
    },
    inputClasses: {
      type: [String, Array, Object],
      default: 'w-auto',
    },
  },
  data() {
    return {
      formData: {
        [this.name]: this.value,
      },
      showActions: false,
    };
  },
  methods: {
    async save() {
      try {
        await this.saveAction(this.formData);

        return Promise.resolve();
      } catch (error) {
        return Promise.reject(error);
      }
    },
    cancel() {
      this.showActions = false;
      this.formData[this.name] = this.value;
    },
  },
};
</script>
